import React from 'react';
import '../../styles/howitworks.scss';

export default function HowitWorksRealtor(props) {
	return (
		<div className="pt-4">
			<br />
			<div className="col-md-12 d-sm-none d-none d-md-block">
				<div className="row">
					<div className="howitworks_img w-100">
						<img src="/assets/images/howitworks_compressed.webp" alt="How It Works" ></img>
					</div>
				</div>
			</div>
			&nbsp;
			<div className="pt-md-4" id="trade">
				<section id="mortgage" name="mortgage">
					<div style={{ textAlign: 'center' }}>
						<h3 style={{ textDecoration: 'none' }}>The Trade-In Mortgage<span style={{ fontSize: '3.5vh', fontFamily: 'system-ui' }}>™</span></h3>
						<h2 className="jost-bold">HOW IT WORKS</h2>
					</div>
				</section>
				<div className="px-md-5">
					<div className="col-12 px-lg-5">
						<div className="d-flex w-100 justify-content-start px-lg-5 top-padding-small">
							<div className="col-auto pl-0 pr-3">
								<div className="how-list primary-background d-flex justify-content-center align-items-center" style={{ color: 'white', backgroundColor: `${props.partner.primary_color ? props.partner.primary_color : '#042F70'}` }}>
									<span className="">1</span>
								</div>
							</div>
							<div className="col px-0">
								<div className="how-content">
									<h4 className="montserrat-semibold">{(props?.pathname.url_path === 'wrenews' || props?.pathname?.url_path === 'jw&!$329654') ? 'Get your home qualified quickly and easily.' : 'Get pre-approved quickly and easily.'}</h4>
									<ul className="pl-3" type="square">
										{
											(props?.pathname.url_path === 'wrenews' || props?.pathname?.url_path === 'jw&!$329654') ?
												<li>
													Fill out our questionnaire <span style={{ fontWeight: 'bolder', cursor: 'pointer', textDecoration: 'underline' }} onClick={(e) => { window.scrollTo(0, 0) }}> here</span> in less than 5 minutes and we will send you a Purchase Price Guarantee (PPG) within 3-5 business days.
												</li>
												: props?.pathname.url_path === 'warburton' ?
												<li>
													Apply in less than 5 minutes and Calque will send you a purchase price guarantee (PPG) within 2-10 business days.
												</li>
												:
												<li>
													Apply in less than 5 minutes and Calque will send you a purchase price guarantee (PPG) within 3-5 business days.
												</li>
										}
										{
											(props?.pathname.url_path === 'wrenews' || props?.pathname?.url_path === 'jw&!$329654') ?
												<li>
													Complete your pre-approval paperwork with a Calque lending partner.
												</li>
												:
												<li>
													Complete your pre-approval paperwork with your Calque lending partner.
												</li>
										}
										{
											(props?.pathname.url_path === 'wrenews' || props?.pathname?.url_path === 'jw&!$329654') ?
												<li>
													<span style={{ fontStyle: 'italic', fontSize: '12px' }}>Note: If your original home doesn’t sell within the specified timeframe (up to 150 days in most markets), Calque will purchase it for the PPG.</span>
												</li>
												: props?.pathname.url_path === 'warburton' ?
												<li>
													<span style={{ fontStyle: 'italic', fontSize: '12px' }}>Note: If your original home doesn’t sell within the specified timeframe (usually 150 days in most markets), Calque will purchase it for the PPG.</span>
												</li>
												:
												<li>
													<span style={{ fontStyle: 'italic', fontSize: '12px' }}>Note: If your original home doesn’t sell within the specified timeframe (usually 120 days in most markets), Calque will purchase it for the PPG.</span>
												</li>
										}
									</ul>
								</div>
							</div>
						</div>
						<div className="d-flex w-100 justify-content-start px-lg-5 top-padding-small">
							<div className="col-auto pl-0 pr-3">
								<div className="how-list primary-background d-flex justify-content-center align-items-center" style={{ color: 'white', backgroundColor: `${props.partner.primary_color ? props.partner.primary_color : '#042F70'}` }}>
									<span className="">2</span>
								</div>
							</div>
							<div className="col px-0">
								<div className="how-content">
									<h4 className="montserrat-semibold">Make competitive offers with confidence.</h4>
									<ul className="pl-3">
										{
											(props?.pathname.url_path === 'wrenews' || props?.pathname?.url_path === 'jw&!$329654') ? null :
												<li>
													Work with us to find your dream home without the worry of having to sell your current home before you move.</li>
										}
										<li>
											{(props?.pathname?.url_path === 'jw&!$329654' || props?.pathname?.url_path === 'jasonwalter') ? 'Submit cash-like offers that aren’t contingent on the sale of your home to win.' : 'Submit non-contingent offers that function like all-cash offers.'}
										</li>
										<li>
											Once your offer is accepted, your Calque lending partner will finalize the underwriting process and give you the down payment for your new home.
										</li>
										{
											(props?.pathname.url_path === 'wrenews' || props?.pathname?.url_path === 'jw&!$329654') ?
												<li>
													Close on your new home!
												</li>
												: null
										}
									</ul>
								</div>
							</div>
						</div>
						<div className="d-flex w-100 justify-content-start px-lg-5 top-padding-small">
							<div className="col-auto pl-0 pr-3">
								<div className="how-list primary-background d-flex justify-content-center align-items-center" style={{ color: 'white', backgroundColor: `${props.partner.primary_color ? props.partner.primary_color : '#042F70'}` }}>
									<span className="">3</span>
								</div>
							</div>
							<div className="col px-0">
								<div className="how-content">
									<h4 className="montserrat-semibold">Move and prep your original home for sale.</h4>

									<ul className="pl-3">
										{
											(props?.pathname.url_path === 'wrenews' || props?.pathname?.url_path === 'jw&!$329654') ?
												<li>Move into your new home!</li> : null
										}
										{
											(props?.pathname.url_path === 'wrenews' || props?.pathname?.url_path === 'jw&!$329654') ?
												<li>Make repairs, stage and show your original home while it's empty so it sells for maximum value.</li> :
												<li>Make repairs and stage your original home so it sells for maximum value.</li>
										}
										{
											(props?.pathname.url_path === 'wrenews' || props?.pathname?.url_path === 'jw&!$329654') ?
												null :
												<li>Use the equity in your original home to make payments on that home so you’re only out-of-pocket for one mortgage.</li>
										}
									</ul>
								</div>
							</div>
						</div>
						<div className="d-flex w-100 justify-content-start px-lg-5 top-padding-small">
							<div className="col-auto pl-0 pr-3">
								<div className="how-list primary-background d-flex justify-content-center align-items-center" style={{ color: 'white', backgroundColor: `${props.partner.primary_color ? props.partner.primary_color : '#042F70'}` }}>
									<span className="">4</span>
								</div>
							</div>
							<div className="col px-0">
								<div className="how-content">
									<h4 className="montserrat-semibold">Sell your original home and save.</h4>
									<ul className="pl-3">
										<li>
											{(props?.pathname.url_path === 'wrenews' || props?.pathname?.url_path === 'jw&!$329654') ? 'Sell' : 'We’ll help you sell'} your original home on the open market for a competitive price.
										</li>
										{(props?.partner?.url_path === "jw&!$329654" || props?.partner?.url_path === "jasonwalter") ? null :
											<li>
												Move forward with a conventional loan on your new home.
											</li>
										}
										{
											(props?.pathname.url_path === 'wrenews' || props?.pathname?.url_path === 'jw&!$329654') ?
												<li>
													We've got your back. If your original home hasn’t sold within the specified timeframe (up to 150 days), Calque will purchase it for the PPG.
												</li>
												:props?.pathname.url_path === 'warburton' ?
												<li>
													If your original home hasn’t sold within the specified timeframe (usually 150 days), Calque will purchase it for the PPG.
												</li>
												:
												<li>
													If your original home hasn’t sold within the specified timeframe (usually 120 days), Calque will purchase it for the PPG.
												</li>
										}
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}